import gql from "@/api/gql.js"
import { query, mutation } from "./queries.js"
import resolveApiErrors from "@/api/resolveApiErrors"

export default {
	async readTotalCounts(variables) {
		const res = await gql({
			query: query.readTotalCounts,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "individuals"
		})
	},

	async readOccurences(variables) {
		const res = await gql({
			query: query.readOccurences,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "individuals"
		})
	}
}
